var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 56",
    style: {
      enableBackground: "new 0 0 52 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_022-factory_x40_2x.png"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,8C8.4,8.1,8.9,7.7,9,7.2C9,7,9.9,2,15,2c2.1,0,3.1,1.5,4.6,4c1.6,2.7,3.6,6,8.4,6c4.7,0,6.5-3.2,7.9-5.8 C37.3,3.6,38.3,2,41,2c5.9,0,6,8.6,6,9c0,0.6,0.4,1,1,1c0,0,0,0,0,0c0.6,0,1-0.4,1-1c0-3.8-1.7-11-8-11c-4,0-5.5,2.8-6.9,5.3 C32.7,7.8,31.5,10,28,10c-3.7,0-5.2-2.5-6.7-5c-1.4-2.4-2.9-5-6.3-5C9.6,0,7.4,4.5,7,6.8C6.9,7.4,7.3,7.9,7.8,8z M39,42 c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C42,43.3,40.7,42,39,42z M39,46c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S39.6,46,39,46z  M51,14h-6c-0.6,0-1,0.4-1,1v19h-6.6L25.7,22.3C25.5,22.1,25.3,22,25,22c-0.6,0-1,0.4-1,1v9.6L13.7,22.3C13.5,22.1,13.3,22,13,22 c-0.6,0-1,0.4-1,1v9.6L1.7,22.3C1.5,22.1,1.3,22,1,22c-0.6,0-1,0.4-1,1v32c0,0.6,0.4,1,1,1h50c0.6,0,1-0.4,1-1V15 C52,14.4,51.6,14,51,14z M50,54H2V25.4l10.3,10.3c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.4,1-1v-9.6l10.3,10.3 c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.4,1-1v-9.6l10.3,10.3c0.2,0.2,0.4,0.3,0.7,0.3h8c0.6,0,1-0.4,1-1V16h4V54z M26,42 c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C29,43.3,27.7,42,26,42z M26,46c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,46,26,46z  M13,42c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C16,43.3,14.7,42,13,42z M13,46c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1 S13.6,46,13,46z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.88802c1fb255ec53b2d8a08128c605c4.svg";
export { ForwardRef as ReactComponent };